import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import logo from '../../../images/logo25.svg';
import theme from '../../../styles/theme';
import { Watermark } from '../../ViewerContainer/bottomInfo/Watermark';

import { makeStyles } from '@egr/xbox/utils/tss-react';

const useStyles = makeStyles({ name: 'CircularProgressPanel' })({
    backdrop: {
        backgroundColor: 'white',
        zIndex: 1301,
        flexDirection: 'column',
        gap: '28px',
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
    },
    label: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: 120,
        height: 38,
    },
    logo: {
        width: 28,
        height: 28,
        display: 'block',
    },
    title: {
        color: theme.palette.text.primary,
        paddingLeft: '15px',
        fontSize: '20px',
    },
    text: {
        color: '#212121',
        fontSize: '12px',
    },
});

type CircularProgressPanelProps = {
    open: boolean;
    percent?: number | null;
};

export const CircularProgressPanel: React.FC<CircularProgressPanelProps> = ({ open, percent }) => {
    const { classes } = useStyles();

    return (
        <Backdrop
            open={open}
            className={classes.backdrop}
        >
            <Box className={classes.logoContainer}>
                <img
                    src={logo}
                    className={classes.logo}
                    width={16}
                    height={16}
                />
                <Typography className={classes.title}>impress</Typography>
            </Box>
            <Box className={classes.wrapper}>
                <CircularProgress
                    color="secondary"
                    size={40}
                    variant="determinate"
                    value={percent ?? undefined}
                />
                <Box className={classes.label}>
                    <Typography className={classes.text}>{typeof percent === 'number' ? `${percent}%` : ''}</Typography>
                </Box>
            </Box>
            <Watermark />
        </Backdrop>
    );
};
